import { withTranslation } from "next-i18next";
import Button from "@components/core/Button";

function SectionButton({
  checkedFilters,
  filterTypesToDisplay = [],
  title,
  onClick,
  t,
}) {
  function displayFiltersSelected() {
    const filtersSelectedTranslated = filterTypesToDisplay.reduce((acc, filterTypeToDisplay) => {
      const filtersSelected = checkedFilters[filterTypeToDisplay];
      if (!filtersSelected) return acc;

      filtersSelected.forEach((filterSelected) => {
        if (filterTypeToDisplay === "brands") {
          acc.push(filterSelected);
        } else {
          acc.push(t(`catalog:filters.${filterTypeToDisplay}.${filterSelected}`));
        }
      });

      return acc;
    }, []).flat();

    if (!filtersSelectedTranslated.length) return null;

    const filtersSelectedString = filtersSelectedTranslated.join(", ");

    return `(${filtersSelectedString})`;
  }

  return (
    <div className="p-3 border-bottom d-flex w-100">
      <Button
        variant="link-dark"
        className="no-underline"
        rightIconName="chevron-right"
        fullWidth
        spaceBetween
        title={title}
        onClick={onClick}
      >
        <span className="me-2 font-weight-normal">{title}</span>

        <span className="filters-selected-list">
          {displayFiltersSelected()}
        </span>
      </Button>
    </div>
  );
}

export default withTranslation("catalog")(SectionButton);